import React from "react";
import * as Mui from "@mui/material";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { SettingsSection } from "component/shared/settings-page";
import { Tag } from "component/shared/tag";
import { User } from "model/user";
import { BillingResource } from "api/resource/billing";
import * as paths from "routes/paths";
import { formatPlanLabel, nextBillingLabel, subscriptionStatusTag } from "./billing-format";
import { useBillingStyles } from "./styles";

interface Props {
	user: User;
	summary: BillingResource;
}

export const PlanDetails: React.FC<Props> = ({ user, summary }) => {
	const { classes } = useBillingStyles();
	const status = subscriptionStatusTag(summary.subscriptionState);
	return (
		<SettingsSection title="Plan Details">
			<div className={classes.detailList}>
				{status && (
					<div>
						<Mui.Typography className={classes.readOnlyLabel}>Status</Mui.Typography>
						<Tag label={status.label} variant={status.variant} size="large" />
					</div>
				)}
				<div>
					<Mui.Typography className={classes.readOnlyLabel}>Current Plan</Mui.Typography>
					<Mui.Typography className={classes.readOnlyValue}>{formatPlanLabel(user) || "—"}</Mui.Typography>
				</div>
				<div>
					<Mui.Typography className={classes.readOnlyLabel}>Billable Lead Owners</Mui.Typography>
					<div className={classes.inlineRow}>
						<Mui.Typography className={classes.readOnlyValue}>{summary.billableLeadOwnerCount}</Mui.Typography>
						{user.permissions.broker && (
							<Router.Link
								to={`${paths.settingsAgents}?billable=1`}
								target="_blank"
								rel="noopener noreferrer"
								className={classes.link}
							>
								View List
								<Icons.ExternalLink size={16} />
							</Router.Link>
						)}
					</div>
				</div>
				<div>
					<Mui.Typography className={classes.readOnlyLabel}>Next Billing Date</Mui.Typography>
					<Mui.Typography className={classes.readOnlyValue}>{nextBillingLabel(summary)}</Mui.Typography>
				</div>
			</div>
		</SettingsSection>
	);
};
